import * as LectureActions from '../actions/lecture'
import { Lecture } from '../models'

export interface State {
  lectures: Lecture[]
  selectedLecture: Lecture
}

const initialState: State = {
  lectures: [],
  selectedLecture: null
}

export function reducer(state: State = initialState, action: LectureActions.All): State {
  switch (action.type) {
    case LectureActions.SET_LECTURES: {
      return { ...state, lectures: action.lectures }
    }
    case LectureActions.SELECT_LECTURE: {
      return { ...state, selectedLecture: action.lecture }
    }
    case LectureActions.ADD_LECTURE: {
      state.lectures.unshift(action.lecture)
      return { ...state, lectures: state.lectures }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/lecture.ts